import { render } from "./NotificationButton.vue?vue&type=template&id=6830f53c"
import script from "./NotificationButton.vue?vue&type=script&lang=js"
export * from "./NotificationButton.vue?vue&type=script&lang=js"

import "./NotificationButton.vue?vue&type=style&index=0&id=6830f53c&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__